(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs-v2"] && !Shopify.designMode) return;
  try {
    
$("[role='tablist'] .nav-link").click(function () {
  $(this)
    .parents("[role='tablist']")
    .find("[role='tab']")
    .removeClass("active");
  $(this).addClass("active");
});
  
$("#faq-tab").click(function () {
  $("#tab-info").removeClass("show");
  $("#tab-info").removeClass("active");
  $("#tab-symptome").removeClass("show");
  $("#tab-symptome").removeClass("active");
  $("#tab-ergebnisbericht").removeClass("show");
  $("#tab-ergebnisbericht").removeClass("active");
  $("#tab-faq").addClass("show");
  $("#tab-faq").addClass("active");
});

$("#faq-tab-mobile").click(function () {
  $("#tab-info").removeClass("show");
  $("#tab-info").removeClass("active");
  $("#tab-symptome").removeClass("show");
  $("#tab-symptome").removeClass("active");
  $("#tab-ergebnisbericht").removeClass("show");
  $("#tab-ergebnisbericht").removeClass("active");
  $("#tab-faq").addClass("show");
  $("#tab-faq").addClass("active");
  // Scroll to the Symptome tab content with an offset
  $('html, body').animate({
    scrollTop: $("#tab-faq").offset().top
  }, 0); // 1000ms animation for smooth scrolling
});

$("#info-tab").click(function () {
  $("#tab-info").addClass("show");
  $("#tab-info").addClass("active");
  $("#tab-faq").removeClass("show");
  $("#tab-faq").removeClass("active");
  $("#tab-symptome").removeClass("show");
  $("#tab-symptome").removeClass("active");
  $("#tab-ergebnisbericht").removeClass("show");
  $("#tab-ergebnisbericht").removeClass("active");
});

$("#info-tab-mobile").click(function () {
  $("#tab-info").addClass("show");
  $("#tab-info").addClass("active");
  $("#tab-faq").removeClass("show");
  $("#tab-faq").removeClass("active");
  $("#tab-symptome").removeClass("show");
  $("#tab-symptome").removeClass("active");
  $("#tab-ergebnisbericht").removeClass("show");
  $("#tab-ergebnisbericht").removeClass("active");
  // Scroll to the Symptome tab content with an offset
  $('html, body').animate({
    scrollTop: $("#tab-info").offset().top
  }, 0); // 1000ms animation for smooth scrolling
});

$("#symptome-tab").click(function () {
  $("#tab-info").removeClass("show");
  $("#tab-info").removeClass("active");
  $("#tab-faq").removeClass("show");
  $("#tab-faq").removeClass("active");
  $("#tab-symptome").addClass("show");
  $("#tab-symptome").addClass("active");
  $("#tab-ergebnisbericht").removeClass("show");
  $("#tab-ergebnisbericht").removeClass("active");
});

$("#symptome-tab-mobile").click(function () {
  $("#tab-info").removeClass("show");
  $("#tab-info").removeClass("active");
  $("#tab-faq").removeClass("show");
  $("#tab-faq").removeClass("active");
  $("#tab-symptome").addClass("show");
  $("#tab-symptome").addClass("active");
  $("#tab-ergebnisbericht").removeClass("show");
  $("#tab-ergebnisbericht").removeClass("active");
  // Scroll to the Symptome tab content with an offset
  $('html, body').animate({
    scrollTop: $("#tab-symptome").offset().top
  }, 0); // 1000ms animation for smooth scrolling
});

$("#ergebnisbericht-tab").click(function () {
  $("#tab-info").removeClass("show");
  $("#tab-info").removeClass("active");
  $("#tab-faq").removeClass("show");
  $("#tab-faq").removeClass("active");
  $("#tab-symptome").removeClass("show");
  $("#tab-symptome").removeClass("active");
  $("#tab-ergebnisbericht").addClass("show");
  $("#tab-ergebnisbericht").addClass("active");
});

$("#ergebnisbericht-tab-mobile").click(function () {
  $("#tab-info").removeClass("show");
  $("#tab-info").removeClass("active");
  $("#tab-faq").removeClass("show");
  $("#tab-faq").removeClass("active");
  $("#tab-symptome").removeClass("show");
  $("#tab-symptome").removeClass("active");
  $("#tab-ergebnisbericht").addClass("show");
  $("#tab-ergebnisbericht").addClass("active");
  $('html, body').animate({
    scrollTop: $("#tab-ergebnisbericht").offset().top
  }, 0);
});
  
$(document).ready(function(){

    var faq_items = document.getElementsByClassName("faq-item");
    var i;

    for (i = 0; i < faq_items.length; i++) {
    faq_items[i].addEventListener("click", function() {
        var panel = this;
        if(panel.classList.contains('collapsed')) {
            panel.classList.add('expanded');
            panel.classList.remove('collapsed');
        } else {
            panel.classList.add('collapsed');
            panel.classList.remove('expanded');
        }
    });
    }
});

  } catch(e) { console.error(e); }
})();
})();
